import { AssetFolder } from './models/Asset';

export const SUPPORT_MESSAGE =
  'Please try again later, or contact our support team at support@bracken.cloud if you keep getting this error.';
export const VIDEO_ENCODING_COMPLETION_CHECK_INTERVAL = 5000; //* ms
export const NOTIFICATION_POLL_INTERVAL = 60000; // ms
export const AUTHOR_ASSETS_FOLDER: AssetFolder = 'author_assets';
export const LEARNER_ASSETS_FOLDER: AssetFolder = 'learner_assets';
export const COMPLETION_SUPPORT_MESSAGE = 'You can now return to the course.';
export const NON_COMPLETION_SUPPORT_MESSAGE =
  "You can choose 'View full lesson' to continue your work or return to the course.";
export const COMPLETION_OPTIONS = 'Choose an option below.';
export const UNFINALISE_ASSESSMENT = `Unfinalising this assessment set it as 'marking in progress' state. You will be able to find the assessment on the 'open assessments' tab.`;
export const USER_DETAILS_REPORT =
  'Changes to user accounts may take up to 15 minutes to appear in the report';
export const MIN_PASSWORD_LENGTH = 6;
/** Regular expression matching email address, see https://stackoverflow.com/a/201378 */
export const EmailRegexp =
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
